import type { useDeveloperHasPermission } from "@services/useDeveloperHasPermission";
import type { useFeatureOn } from "@services/useFeatureOn";

export const getViewPermission = (
  featureOn: ReturnType<typeof useFeatureOn>,
  hasPermission: ReturnType<typeof useDeveloperHasPermission>
) => {
  const hasCorrectPermissions =
    hasPermission("appGroup", {
      permission: "basicReadOnly",
    }) ||
    hasPermission("appGroup", {
      permission: "manageFeatureFlags",
    });

  let viewPermission = false;
  if (featureOn("feature_flags_permissions_management")) {
    viewPermission = hasPermission("appGroup", {
      permission: "viewFeatureFlags",
    });
  }

  return featureOn("feature_flags") && (hasCorrectPermissions || viewPermission);
};
